export const GET_WORKLOG_DATA = 'workLog/GET_WORKLOG_DATA'
export const GET_WORKLOG_DATA_DONE = 'workLog/GET_WORKLOG_DATA_DONE'
export const GET_WORKLOG_DATA_FAIL = 'workLog/GET_WORKLOG_DATA_FAIL'

export const ADD_WORK_TO_WORKLOG = 'workLog/ADD_WORK_TO_WORKLOG'
export const UPDATE_WORK_IN_WORKLOG = 'workLog/UPDATE_WORK_IN_WORKLOG'

export const DELETE_WORK_IN_WORKLOG = 'workLog/DELETE_WORK_IN_WORKLOG'
export const DELETE_WORK_IN_WORKLOG_DONE = 'workLog/DELETE_WORK_IN_WORKLOG_DONE'
export const DELETE_WORK_IN_WORKLOG_FAIL = 'workLog/DELETE_WORK_IN_WORKLOG_FAIL'

export const DELETE_DAY_ACTION = 'workLog/DELETE_DAY_ACTION'
export const DELETE_DAY_ACTION_DONE = 'workLog/DELETE_DAY_SUCCESS'
export const DELETE_DAY_ACTION_FAIL = 'workLog/DELETE_DAY_ACTION_FAIL'

// Этапы загрузки данных работодателя
export const GET_ACTIVE_EMPLOYEE_LIST = 'workLog/GET_ACTIVE_EMPLOYEE_LIST'
export const GET_ACTIVE_EMPLOYEE_LIST_DONE = 'workLog/GET_ACTIVE_EMPLOYEE_LIST_DONE'
export const GET_ACTIVE_EMPLOYEE_LIST_FAIL = 'workLog/GET_ACTIVE_EMPLOYEE_LIST_FAIL'

export const GET_FIRED_EMPLOYEE_LIST = 'workLog/GET_FIRED_EMPLOYEE_LIST'
export const GET_FIRED_EMPLOYEE_LIST_DONE = 'workLog/GET_FIRED_EMPLOYEE_LIST_DONE'
export const GET_FIRED_EMPLOYEE_LIST_FAIL = 'workLog/GET_FIRED_EMPLOYEE_LIST_FAIL'

export const GET_EMPLOYEE_DATES = 'workLog/GET_EMPLOYEE_DATES'
export const GET_EMPLOYEE_DATES_DONE = 'workLog/GET_EMPLOYEE_DATES_DONE'
export const GET_EMPLOYEE_DATES_FAIL = 'workLog/GET_EMPLOYEE_DATES_FAIL'

export const GET_WORK_BY_DATE = 'workLog/GET_WORK_BY_DATE'
export const GET_WORK_BY_DATE_DONE = 'workLog/GET_WORK_BY_DATE_DONE'
export const GET_WORK_BY_DATE_FAIL = 'workLog/GET_WORK_BY_DATE_FAIL'

// UI State Management
export const SET_ACTIVE_WORK_LOG_ORG = 'workLog/SET_ACTIVE_WORK_LOG_ORG'
export const SET_ACTIVE_TAB = 'workLog/SET_ACTIVE_TAB'
export const SET_ACTIVE_TAB_EMPLOYER = 'workLog/SET_ACTIVE_TAB_EMPLOYER'
export const SET_SELECTED_CAROUSEL_DATE = 'workLog/SET_SELECTED_CAROUSEL_DATE'
export const SET_EMPLOYEE_SELECTED_CAROUSEL_DATE = 'workLog/SET_EMPLOYEE_SELECTED_CAROUSEL_DATE'
export const SET_DISABLED_DATES = 'workLog/SET_DISABLED_DATES'
export const SET_EMPLOYEE_DISABLED_DATES = 'workLog/SET_EMPLOYEE_DISABLED_DATES'
export const SET_SELECTED_EMPLOYEE = 'workLog/SET_SELECTED_EMPLOYEE'
export const SET_SEARCH_QUERY = 'workLog/SET_SEARCH_QUERY'
export const SET_NEWLY_ADDED_DATES = 'workLog/SET_NEWLY_ADDED_DATES'
export const SET_ERROR_MESSAGE = 'workLog/SET_ERROR_MESSAGE'

// Modal Management
export const SET_MODAL_STATE = 'workLog/SET_MODAL_STATE'
export const RESET_MODAL_STATES = 'workLog/RESET_MODAL_STATES'

// Date Picker Management
export const SET_DATE_PICKER_STATE = 'workLog/SET_DATE_PICKER_STATE'
export const SET_SELECTED_DATE = 'workLog/SET_SELECTED_DATE'

// Reset State
export const RESET_EMPLOYEE_DATA = 'workLog/RESET_EMPLOYEE_DATA'
export const RESET_ORG_DATA = 'workLog/RESET_ORG_DATA'
export const RESET_WORKLOG_STATE = 'workLog/RESET_WORKLOG_STATE'

export const COMPANY_ALLOWED = 'workLog/COMPANY_ALLOWED'
export const COMPANY_ALLOWED_DONE = 'workLog/COMPANY_ALLOWED_DONE'
export const COMPANY_ALLOWED_FAIL = 'workLog/COMPANY_ALLOWED_FAIL'
